<template lang="pug">
div
  PageTitle(
    :pagetitle = "pagetitle",
    :tip = "tip")
    span.floatr(v-if="dianjingIDList.length > 0")
      label 账号切换：
      v-select(
        v-model="dianjingID",
        :options="dianjingIDList",
        @input="dianjingIDChange"
      )
  CompTimeSpan(
    :compared="compared",
    @rangeChange="getAppData",
    @compRangeChange="compRangeChange")

  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")
      IndiceCompare(
        :compared="compared",
        :indicesMenu="indicesMenu",
        @indiceChange="indiceChange",
        :indice="customIndice",
        :compIndice="twoIndice",
        :twoIndiceShow="twoIndiceShow")

    LineChart(
      :yAxis="yAxis",
      :legend="legend",
      :xAxis="chartXAxis",
      :series="chartSeries")

  .zone
    TableTitle(icon="fa fa-list", :title="tableTabTitle")
    div
      slot(name='nav-tabs')
    complex-table(
      :columns="columns",
      :list="tableDataList",
      :sum="sum",
      :checkbox="hasCheckBox",
      :checkbox_length="checkboxLength",
      :sortKey="order",
      :sortOrder="isasc")
    v-pagination(
      :total="total",
      :pn="pg",
      :ps="ps",
      v-if="total > ps",
      @updatepage="updatePage")

</template>
<script>
/* global _ */
import { mapState, mapActions } from 'vuex'
import Store from '../../store/store.js'
import Table from '../../component/complex-table.vue'
import Mixin from '../mixin.js'

export default {
  store: Store,
  mixins: [Mixin],
  props: {
    total: Number,
    pg: Number,
    ps: Number,
    pagetitle: String,
    tip: String,
    currentTab: String,
    tablist: Array,
    tableDataList: {
      type: Array,
      default: () => []
    },
    hasCheckBox: {
      type: Boolean,
      default: false
    },
    checkboxLength: {
      type: Number,
      default: 3
    },
    yAxis: {
      type: Array,
      default: () => []
    },
    order: {
      type: String,
      default: 'date'
    },
    isasc: {
      type: Number,
      default: 0
    },
    sum: {
      type: [String, Object],
      default: () => {}
    },
    legend: {
      type: Array,
      default: () => []
    },
    chartXAxis: {
      type: Array,
      default: () => []
    },
    chartSeries: {
      type: Array,
      default: () => []
    },
    customIndice: {
      type: String,
      default: 'adpv'
    },
    twoIndice: {
      type: String,
      default: ''
    },
    twoIndiceShow: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'complex-table': Table
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('app', {
      indicesMenu: state => state.indicesMenu,
      dianjingID: state => state.dianjingID,
      dianjingIDList: state => state.dianjingIDList,
      compared: state => state.compared,
      compareStart: state => state.compareStart,
      compareEnd: state => state.compareEnd
    }),
    start () {
      return this.$store.state.start.replace(/-/g, '/')
    },
    end () {
      return this.$store.state.end.replace(/-/g, '/')
    },
    tableTabTitle () {
      return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
    },
    columns () {
      const columns = [
        {
          title: '分析维度',
          width: 200,
          children: [
            {
              title: '推广趋势',
              key: 'name',
              render: (index, value, item, type) => {
                if (type === 'date') {
                  return value.split(' ')[0]
                }
                return this.textEllipsidRender(index, value, item)
              }
            }
          ]
        },
        {
          title: '推广指标',
          children: [
            {
              title: '展现量',
              key: 'adpv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '点击量',
              key: 'adclick',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '点击率',
              key: 'adctr',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            },
            {
              title: '消费',
              key: 'adcost',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'CPC',
              key: 'adcpc',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'CPM',
              key: 'adcpm',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            }
          ]
        }
      ]
      const currentTabItem = _.find(this.tablist, {id: this.currentTab})
      columns[0].children[0].title = _.has(currentTabItem, 'name') ? currentTabItem.name : '推广趋势'
      columns[0].children[0].key = _.has(currentTabItem, 'key') && !this.compared ? currentTabItem.key : 'name'
      return columns
    }
  },
  watch: {
    dianjingIDList (newVal) {
      if (newVal.length > 1) {
        this.getAppData()
      }
    }
  },
  methods: {
    ...mapActions('app', {
      setDianjingId: 'SET_DIANJINGID',
      setDinajingIdList: 'SET_DIANJINGID_LIST',
      setCompared: 'SET_COMPARED'
    }),
    sorter (key, order) {
      this.$emit('tablesorter', {key, order})
    },
    // 切换图标维度
    indiceChange (obj) {
      this.$emit('indiceChange', obj)
    },
    // 对比时间更新
    compRangeChange (comparedObj) {
      this.setCompared(comparedObj)
      this.chartResList = []
      this.$emit('tableUpdate')
    },
    // 重置compared并获取数据
    resetCompared () {
      this.setCompared({compared: false, compStart: '', compEnd: ''})
      this.chartResList = []
      this.$emit('tableUpdate')
    },
    getAppData () {
      if (this.dianjingIDList.length > 1) {
        // 获取table数据
        this.resetCompared()
      }
    },
    dianjingIDChange (val) {
      this.$emit('clearKeyword')
      this.setDianjingId(val)
      this.getAppData()
    },
    updatePage (pn) {
      this.$emit('tableUpdate', pn)
    }
  }
}
</script>




// WEBPACK FOOTER //
// template.vue?309b9069